import { Route, Routes } from "react-router-dom";
import SensorSetting from "pages/management/setting/iot/sensor";
import SensorViewSetting from "pages/management/setting/iot/sensor-view";
import RouteAccessError from "pages/RouteAccessError";
import PermissionRoute from "components/route/PermissionRoute";
import { PERMISSIONS } from "config/permissions";

export default function MonitoringSettingSensorRoutes(props) {

    return (
        <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_IOT_READ}
                        >
                            <SensorSetting />
                        </PermissionRoute>
                    }
                />
                <Route path=":id" 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_IOT_READ}
                        >
                            <SensorViewSetting />
                        </PermissionRoute> 
                    }
                 />
                <Route path="*" element={ <RouteAccessError /> }/>
            </Route>
        </Routes>
    );
}